import { useEffect, useRef, EffectCallback, DependencyList } from "react"

/**
 * Runs an effect only after the component has mounted.
 * Skips the first render.
 */
export function useEffectAfterMount(effect: EffectCallback, deps: DependencyList) {
    const didMount = useRef(false)

    useEffect(() => {
        if (didMount.current) {
            return effect()
        } else {
            didMount.current = true
        }
    }, deps)
}
